import { useEffect, useState } from 'react';

/** Whether a CSS media query matches (false where matchMedia is unavailable). */
export function useMediaQuery(query: string): boolean {
  const get = () =>
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia(query).matches;
  const [matches, setMatches] = useState(get);
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const list = window.matchMedia(query);
    const onChange = () => setMatches(list.matches);
    onChange();
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  }, [query]);
  return matches;
}

/** Below this width, panes become tabs (PLAN §4.3). */
export const NARROW = '(max-width: 900px)';
